import { ConfirmAction } from 'components';
import { RollbackOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useRestoreUserMutation } from 'app/services/users';
import { User } from 'app/services/users/types';

type DeleteButtonProps = {
  user: User | undefined,
  minimized?: boolean,
}

const Restore = ({ user, minimized }: DeleteButtonProps) => {
  const { t } = useTranslation();
  const [ restoreUser, meta ] = useRestoreUserMutation();

  if (!user?.Deleted) return null;

  return (
    <ConfirmAction
      callback={() => user && restoreUser(user.Id)}
      successMessage={t('common.restoresuccess', { content: user?.FirstLastName })}
      confirmMessage={t('common.restoreconfirm', { content: user?.FirstLastName })}
      meta={meta}
      tooltipButtonProps={{
        title: t('common.restore'),
        minimized: minimized,
        buttonProps:{
          icon: <RollbackOutlined />,
          type: 'link',
        }
      }}
    />
  );
};

export default Restore;

